import { Container } from "../styles/NotFound";

export const NotFound = () => <Container>Not Found</Container>;
